import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { UblService } from "@/plugins/ubl/services/ubl-service";

export class UblArchiveCreatedNotification extends Notification {
	public async onClick(vue: Vue):Promise<INotificationOnClickResult> {
		let file = await UblService.getArchive(parseInt(this.Data.fileId || "0"));
		await UblService.downloadArchive(file);
		return {};
	}

	public getIcon():string {
		return "file";
	}

	public getTone():string {
		return "info";
	}

	public getActionKey():string {
		return "download";
	}
}
